<app-wait-for-medic></app-wait-for-medic>
<div id="videosWrapper" #videosWrapper></div>
<div id="footer" #footer>
  <app-controls
    [cid]="cid"
    [m]="isMedic"
    [enableHangup]="activeHangup"
  ></app-controls>
  <aside>
    <p>Navegador recomendado</p>
    <img
      src="../../../assets/img/google-chrome.png"
      alt="Logo de Google Chrome"
    />
  </aside>
  <app-timer *ngIf="showTimer" (enableBtn)="enableHangup($event)"></app-timer>
</div>
<ngx-spinner>
  <p style="font-size: 20px; color: white; text-align: center">
    Espere un momento...
  </p>
</ngx-spinner>
